module.exports = __webpack_public_path__ + "img/jcb.807e5338.png";